// @ts-nocheck
import { noop, toNumber } from 'lodash'
import React, { CSSProperties, HTMLAttributes } from 'react'
import styled from 'styled-components'

import { propsToVariant, TPropsToVariant } from '../bootstrapHelper'
import PopoverTrigger from '../PopoverTrigger'
import { TPlacement } from '../Popup'
import TransitionMantineTooltip from '../TransitionMantineTooltip'

export interface IIcon extends TPropsToVariant, HTMLAttributes<any> {
  /** Color of the icon */
  color?: string

  /** CSS class name of the icon, check out font awesome icon */
  icon?: string

  /** Size of the icon in " rem" */
  size?: string | number

  /** Call back when click on the icon */
  onClick?: (e?: React.MouseEvent<any>) => void

  /** Render Tooltip content when hover on the icon */
  tooltip?: string

  /** Render Popover content when hover */
  popover?: string

  /** CSS class name of the Icon container */
  className?: string

  /** Position of the popover */
  placement?: TPlacement

  /** Text content after the icon */
  text?: string
  /** set Icon center content  */
  justifyCenter?: boolean
  inheritLineHeight?: boolean
  iconStyle?: CSSProperties
}

type TWrapper = {
  color?: string
  size?: number | string
  checkCursor?: boolean
}

const Wrapper = styled.i<TWrapper>`
  color: ${({ color }) => color};
  font-size: ${({ size }) => toNumber(size)}rem;
  cursor: ${({ checkCursor }) => (checkCursor ? 'pointer' : '')};
`

const Icon = (props: IIcon): React.ReactElement => {
  const {
    color = '',
    icon,
    size = 1,
    onClick,
    tooltip,
    popover,
    className,
    placement,
    text,
    justifyCenter,
    inheritLineHeight = false,
    iconStyle = {},
    ...rest
  } = props

  let textClass = ''
  const variantColor = propsToVariant(props, 'none')
  if (variantColor !== 'none') {
    textClass = `text-${variantColor}`
  }

  let outer = (
    <div
      className={`d-flex align-items-center ${
        justifyCenter ? 'justify-content-center w-100 h-100' : ''
      }`}
    >
      <Wrapper
        className={`${icon} ${textClass}`}
        color={color}
        size={size}
        checkCursor={!!onClick}
        onClick={onClick || noop}
        {...rest}
      />
      {text && <div className="ml-1">{text}</div>}
    </div>
  )
  if (tooltip) {
    outer = (
      <TransitionMantineTooltip tooltip={tooltip}>
        {outer}
      </TransitionMantineTooltip>
    )
  }
  if (popover) {
    outer = (
      <PopoverTrigger placement={placement} element={popover}>
        {outer}
      </PopoverTrigger>
    )
  }

  return (
    <div
      className={`d-inline-block  ${className ? className : ''}`}
      style={{ lineHeight: inheritLineHeight ? 'inherit' : '1', ...iconStyle }}
    >
      {outer}
    </div>
  )
}

export default Icon
